import { Stack } from '@mui/material';
import type { Condition, ResourceType } from '@repo/api-gw-sdk';

import type { FilterProperty } from '@/types/advanceFilter';

import {
  ResourceSelectionDynamicViewer,
  type ResourcesScopeType,
} from './resourceSelectionDynamicViewer';
import { ResourceSelectionManualViewer } from './resourceSelectionManualViewer';

export const ResourcesSelectionViewer = ({
  condition,
  conditionTitle,
  resourcesScopeType,
  include,
  exclude,
  dynamicResourcesHeader,
  allExcludedDescription,
  allIncludedDescription,
  supportProperties,
  selectedResourceTypes,
}: {
  condition?: Condition;
  conditionTitle: React.ReactNode;
  resourcesScopeType: ResourcesScopeType;
  include: string[];
  exclude: string[];
  dynamicResourcesHeader: React.ReactNode;
  allExcludedDescription: string;
  allIncludedDescription: string;
  supportProperties: FilterProperty[];
  selectedResourceTypes?: ResourceType[];
}) => {
  return (
    <Stack gap={'40px'} width='100%'>
      <Stack gap={'24px'}>
        {dynamicResourcesHeader}
        <ResourceSelectionDynamicViewer
          condition={condition}
          conditionTitle={conditionTitle}
          resourcesScopeType={resourcesScopeType}
          allExcludedDescription={allExcludedDescription}
          allIncludedDescription={allIncludedDescription}
          supportProperties={supportProperties}
          selectedResourceTypes={selectedResourceTypes}
        />
      </Stack>
      {include.length + exclude.length > 0 && (
        <ResourceSelectionManualViewer include={include} exclude={exclude} />
      )}
    </Stack>
  );
};
